import _objectSpread from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
import FetchError from "../../components/FetchError.vue";
import providerApiService from "../../services/api/ProviderApiService";
export default {
  components: {
    FetchError: FetchError
  },
  name: "EmployeeAbilities",
  data: function data() {
    return {
      abilities: [],
      selectedAbilities: [],
      error: null
    };
  },
  mounted: function mounted() {
    if (this.selectedEmployee) this.getAbilities(this.selectedEmployee.id);
  },
  computed: _objectSpread({}, mapGetters({
    currentProvider: "profile/currentProvider"
  })),
  methods: {
    getAbilities: function getAbilities(employeeId) {
      var _this = this;

      this.$vs.loading();
      this.selectedAbilities = [];
      this.abilities = [];
      providerApiService.getEmployeeAbilities(this.currentProvider.id, employeeId).then(function (result) {
        _this.setGroupByAbilitiesData(result.data);

        _this.initialSelectedAbilities(result.data);
      }).catch(function (err) {
        return _this.error = err;
      }).finally(function () {
        return _this.$vs.loading.close();
      });
    },
    selectAbility: function selectAbility(abilityId) {
      //in here you can check what ever condition  before append to array.
      if (this.selectedAbilities.includes(abilityId)) {
        this.selectedAbilities = this.selectedAbilities.filter(function (item) {
          return item !== abilityId;
        });
      } else {
        this.selectedAbilities.push(abilityId);
      }
    },
    initialSelectedAbilities: function initialSelectedAbilities(abilities) {
      var _this2 = this;

      abilities.forEach(function (item) {
        if (item.value) {
          _this2.selectedAbilities.push(item.id);
        }
      });
    },
    save: function save() {
      var _this3 = this;

      this.$vs.loading();
      providerApiService.addAbilities(this.currentProvider.id, this.selectedEmployee.id, this.selectedAbilities).then(function () {
        _this3.$vs.notify({
          text: "عملیات با موفقیت انجام شد",
          color: "success",
          position: "bottom-center"
        });

        window.location.reload();
      }).catch(function (err) {
        _this3.$vs.notify({
          text: err.getErrorDescriptions(),
          color: "danger",
          position: "bottom-center"
        });
      }).finally(function () {
        _this3.$vs.loading.close();
      });
    },
    deleteEmployee: function deleteEmployee() {
      var _this4 = this;

      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "\u062D\u0630\u0641 \u06A9\u0627\u0631\u0645\u0646\u062F",
        text: "\u0627\u0632 \u062D\u0630\u0641 \u06A9\u0627\u0631\u0645\u0646\u062F \"".concat(this.selectedEmployee.name || this.selectedEmployee.phone, "\" \u0627\u0637\u0645\u06CC\u0646\u0627\u0646 \u062F\u0627\u0631\u06CC\u062F\u061F"),
        acceptText: "بلی",
        cancelText: "خیر",
        accept: function accept() {
          _this4.$vs.loading();

          providerApiService.deleteEmployee(_this4.currentProvider.id, _this4.selectedEmployee.phone).then(function () {
            _this4.$emit("employeeDeleted");

            _this4.$vs.notify({
              text: "کارمند با موفقیت حذف شد",
              position: "bottom-center",
              color: "success"
            });
          }).finally(function () {
            return _this4.$vs.loading.close();
          });
        }
      });
    },
    setGroupByAbilitiesData: function setGroupByAbilitiesData(data) {
      var ordersAbilities = {
        title: "سفارشات",
        data: []
      };
      var productsAbilities = {
        title: "محصولات فروشگاه",
        data: []
      };
      var panelAbilities = {
        title: "پنل مدیریتی",
        data: []
      };
      data === null || data === void 0 ? void 0 : data.forEach(function (item) {
        switch (item.scope) {
          case "orders":
            ordersAbilities.id = item.scope;
            ordersAbilities.data.push(item);
            return;

          case "categories":
          case "items":
            productsAbilities.id = item.scope;
            productsAbilities.data.push(item);
            return;

          default:
            panelAbilities.id = item.scope;
            panelAbilities.data.push(item);
            return;
        }
      });
      this.abilities = this.abilities.concat(ordersAbilities, productsAbilities, panelAbilities);
    }
  },
  watch: {
    selectedEmployee: function selectedEmployee(employee) {
      this.getAbilities(employee.id);
    }
  },
  props: {
    selectedEmployee: {
      type: Object,
      required: true
    }
  }
};